import React from "react";

const ConfirmationDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = "CONFIRM",
  cancelLabel = "CANCEL",
  onConfirm,
  onCancel,
  confirmColor = "#F74F25", // default orange
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md text-center">
        {/* Title */}
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
          {title}
        </h2>

        {/* Optional Message */}
        {message && (
          <p className="text-gray-500 mb-6 text-sm">{message}</p>
        )}

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-[24px]">
          <button
            onClick={onCancel}
            className="border border-primary-default text-primary-default font-semibold px-6 py-2 rounded-md hover:bg-primary-default/10 transition"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            style={{ backgroundColor: confirmColor }}
            className="text-white font-semibold px-6 py-2 rounded-md hover:opacity-90 transition"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
